import supportedLanguagesJson from "./supported-languages.json"

export const fallbackLng = 'en' //设置默认的语言，如果用户url不带语言，默认会使用这个语言
export const defaultNS = 'translation'
export const namespaces = ['translation', 'countries', 'home', 'product', 'checkout', 'verifications'] // 所有支持的 namespace

// Single source of truth for the locale list. The data lives in
// supported-languages.json so both the TS runtime *and* next.config.js (CJS,
// runs on the build server's Node — which may not support TS) can read it.
export const supportedLanguages: ReadonlyArray<{ locale: string; name: string }> =
  supportedLanguagesJson

export const languagesLocale = supportedLanguages.map((t) => t.locale)


export function getOptions (lng = fallbackLng, ns:string|string[] = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languagesLocale,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns: Array.isArray(ns) ? ns : [ns],
    // 移除 load: 'languageOnly' - 保持默认的 'all' 模式，这样可以正确加载 ja-JP、zh-CN 等完整 locale
  }
}

// 定义 Web URL 语言代码到 Flutter/Strapi legacy locale key 的映射。
// 注意：韩语在 Web/i18next 中是 `ko`，Antom cashier 使用 `ko_KR`，但 Flutter
// 资源和 Strapi `title_i18n_map` 仍使用 legacy key `kr_KR`。不要把这里改成
// `ko_KR`，否则国家/地区列表等读取 legacy map 的地方会取不到韩语文案。
export const langToMapKey = {
  'en': 'en_US', // 默认英语使用美式英语
  'es': 'es_ES',
  'zh-CN': 'zh_CN',
  'ru-RU': 'ru_RU',
  'ja-JP': 'ja_JP',
  'fr-FR': 'fr_FR',
  'ko': 'kr_KR',
    'hi-IN': 'hi_IN',
  'pt-PT': 'pt_PT',
  'zh-TW': 'zh_TW',
  'de-DE': 'de_DE',
  'ar-SA': 'ar_SA',
  'it-IT': 'it_IT',
  'id-ID': 'id_ID',
  'th-TH': 'th_TH',
  'nl-NL': 'nl_NL',
  'vi-VN': 'vi_VN',
  'ms-MY': 'ms_MY',
  'uk-UA': 'uk_UA',
  'tr-TR': 'tr_TR',
  'pl-PL': 'pl_PL',
  'ro-RO': 'ro_RO',
  'cs-CZ': 'cs_CZ',
  'hu-HU': 'hu_HU',
  'el-GR': 'el_GR',
  'sv-SE': 'sv_SE',
  'nb-NO': 'no_NO', // 修正：Dart中使用no_NO
  'da-DK': 'da_DK',
  'fi-FI': 'fi_FI',
  'he-IL': 'he_IL',
  'bn-BD': 'bn_BD',
  'ur-PK': 'ur_PK',
  'km-KH': 'km_KH',
  'sr-Cyrl-RS': 'sr_RS', // 修正：Dart中使用sr_RS
  'hr-HR': 'hr_HR',
  'sl-SI': 'sl_SI',
  'sk-SK': 'sk_SK',
  'bg-BG': 'bg_BG',
  'et-EE': 'et_EE',
  'lv-LV': 'lv_LV',
  'lt-LT': 'lt_LT',
  'fa-IR': 'fa_IR',
  // 添加Dart中存在的语言
  'pt-BR': 'pt_BR', // 巴西葡萄牙语
  'zh-HK': 'zh_HK', // 香港中文
  'es-LA': 'es_LA', // 拉丁美洲西班牙语
  'ar-EG': 'ar_EG', // 埃及阿拉伯语
  'fr-CA': 'fr_CA', // 加拿大法语
  // 注意：以下语言在Dart中不存在，已移除
  // 'si-LK', 'my-MM', 'sw-TZ', 'ha-Latn', 'zu-ZA', 'hy-AM', 'sq-AL', 
  // 'kk-Cyrl-KZ', 'ka-GE', 'eu-ES', 'ca-ES', 'gl-ES', 'nn-NO'
};
